import { render, staticRenderFns } from "./show-versions.vue?vue&type=template&id=74e9c332&scoped=true&"
import script from "./show-versions.vue?vue&type=script&lang=js&"
export * from "./show-versions.vue?vue&type=script&lang=js&"
import style0 from "./show-versions.vue?vue&type=style&index=0&id=74e9c332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9c332",
  null
  
)

export default component.exports